import React from 'react';
import PropTypes from 'prop-types';
import ScrollWrapper from '@components/Atoms/ScrollWrapper';
import CommonUtils, { countLines } from '../../utils/commonUtils';
import { NavigationContentWrap } from './QuestionAssets.style';
import addImageErrorListener from '../../utils/errorCapture';
import { useFeatureFlagEnabled } from '@components/Atoms/FeatureFlagGuard/hooks';
import { FEATURE_STATIC_PASSAGE_REFERENCE_MIGRATION } from '@components/Atoms/FeatureFlagGuard/constants';

const scrollStyle = {
  height: 'calc(100vh - 9em)',
  width: '100%',
};

const scrollStyleWithFooter = {
  height: 'calc(100vh - 12em)',
  width: '100%',
};

// type Reading Passage and Answer
const AssetTypeSpecial = ({ asset, hasFooter, scrollBarStyle }) => {
  const assetRef = React.useRef(null);
  const { asset_type: assetType, text } = asset;
  const isStaticPassageReferenceMigrationEnabled = useFeatureFlagEnabled({
    featureName: FEATURE_STATIC_PASSAGE_REFERENCE_MIGRATION,
  });
  // Default to legacy behavior while flag is loading (undefined) to avoid visual flash
  const useLegacyRuntimeContentTransforms = isStaticPassageReferenceMigrationEnabled !== true;
  const html = React.useMemo(
    () => CommonUtils.sharedAssetsStandardize(text, assetType).replace(/\\r\\n/g, ''),
    [text, assetType],
  );
  const defaultScrollbarStyle = hasFooter ? scrollStyleWithFooter : scrollStyle;

  React.useEffect(() => {
    if (assetRef.current) {
      const hasBakedLineNumbers = /<span[^>]*class\s*=\s*["'][^"']*\bline-no\b/i.test(html);
      if (useLegacyRuntimeContentTransforms && !hasBakedLineNumbers) {
        countLines(assetRef.current, 0);
      }
      const cleanup = addImageErrorListener(assetRef.current);
      return cleanup; // Cleanup observer on unmount
    }
  }, [html, useLegacyRuntimeContentTransforms]);

  return (
    <ScrollWrapper autoHide sx={{ ...defaultScrollbarStyle, ...scrollBarStyle }} contentProps={{ tabIndex: 0 }}>
      <NavigationContentWrap dangerouslySetInnerHTML={{ __html: html }} ref={assetRef} />
    </ScrollWrapper>
  );
};

AssetTypeSpecial.propTypes = {
  asset: PropTypes.object,
  hasFooter: PropTypes.bool,
  scrollBarStyle: PropTypes.any,
};

export default AssetTypeSpecial;
